module.exports = __webpack_public_path__ + "img/banner-1-m.619d2a61.jpg";